import { motion } from 'motion/react';

interface Props {
  children: React.ReactNode;
  [key: string]: any;
}

const FadeSlide = ({ children, ...props }: Props) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default FadeSlide;
